.takes {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: var(--tuna-spacing-1);
}

.list {
  display: flex;
  flex-wrap: wrap;
  gap: var(--tuna-spacing-1);
  margin: 0;
  padding: 0;
  list-style: none;
}

.take {
  display: flex;
  align-items: center;
  gap: var(--tuna-spacing-0_5);
  padding: 0 var(--tuna-spacing-0_5);
  border: 1px solid var(--tuna-border-subtle);
  border-radius: var(--tuna-shape-borderRadius);
}

/* The current take: by its border and weight, and `aria-current` on the take (WCAG 1.4.1) */
.current {
  border-color: var(--tuna-palette-primary-main);
  font-weight: 600;
}

.name {
  padding: 0 var(--tuna-spacing-0_5);
  color: var(--tuna-content-primary);
}

.nameField {
  font: inherit;
  padding: var(--tuna-spacing-0_5);
  border: 1px solid var(--tuna-border-default);
  border-radius: var(--tuna-shape-borderRadius);
  background: var(--tuna-surface-elevated);
  color: var(--tuna-content-primary);
}

/* Spec §9: 44px targets on touch */
@media (pointer: coarse) {
  .take > *,
  .takes > button {
    min-height: 44px;
  }
}
